import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SanityProductFilter } from '@gelato-api-ui/core/sanity/sanity-product-filter';
import { SanityProductControlOption } from '@gelato-api-ui/core/sanity/sanity-product-control-option';

@Component({
  selector: 'gd-product-templates-list-item-filter-regular',
  templateUrl: './product-templates-list-item-filter-regular.component.html',
  styleUrls: ['./product-templates-list-item-filter-regular.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductTemplatesListItemFilterRegularComponent {
  @Input() filter: SanityProductFilter;

  get optionValues(): string {
    return (this.filter?.options || [])
      .map((loopOption: SanityProductControlOption): string => loopOption?.title)
      .join(', ');
  }
}
